// extracted by mini-css-extract-plugin
export default {"container":"style--container--166ee7","header":"style--header--15cc7d","name":"style--name--acee71","row":"style--row--1dc2d6"};